import type { ReactNode } from 'react';
import { Alert, Button, Spinner } from '@skupreme/shared/ui';
import type { UseQueryResult } from '@tanstack/react-query';

type QueryViewProps<T> = {
  query: UseQueryResult<T>;
  children: (data: T) => ReactNode;
};

/** Loading and error states for a query; the children render the loaded data. */
export function QueryView<T>({ query, children }: QueryViewProps<T>) {
  if (query.isPending) {
    return (
      <div className="sk:flex sk:justify-center sk:py-8">
        <Spinner label="Loading" />
      </div>
    );
  }
  if (query.isError) {
    return (
      <Alert
        tone="danger"
        title="Could not load this"
        action={
          <Button size="sm" onPress={() => void query.refetch()}>
            Retry
          </Button>
        }
      >
        {query.error.message}
      </Alert>
    );
  }
  return <>{children(query.data)}</>;
}
